
import { defineComponent, ref, reactive, getCurrentInstance } from "vue";
import JsxTemp from "./demo.jsx";

export default defineComponent({
  name: "alpModal",
  components: {
    JsxTemp,
  },
  data: function () {
    return {
      //插槽
      slot: {
        modal: [],
      },
      tabelKey: 1,
      // 弹窗配置
      popupConfig: {
        selRow: [],
        selData: [],
        show: false,
        // 顶部查询栏
        topFormKey: 1, // 更新key
        topSearchFormData: {}, // 表单初始化默认值
        topSearchFormShrink: false, // 查询栏收缩
        topFormHeight: 0, // 查询栏高度
        tableMajorKey: "", // 表格主键
        // 表格数据
        tableData: [],
        // 表格列配置
        columns: [],
        // 表格高度
        tableViewHeight: 270,
        // 表格行数据
        tableRowFormData: {},
        // 表格选中行
        selectedRowKeys: [],
        // 选中数据
        selectedData: [],
        // 部门树 配置/选中 数据
        // 字段对应配置

        // 查询key
        searchTreeKey: "",
        // 是否收缩
        fold: false,
        // 是否全选
        selAll: false,
        // 部门树 数据
        deptData: [],
        deptTreeData: [],
        // 部门树展开key
        deptExpandedKeys: [],
        // 部门树选中节点key
        deptCheckedKeys: [],
        // 部门树节点key
        allDeptNodeKeys: [],
      },
    };
  },
  props: {
    type: String,
    isShow:Boolean,
    value: Array || String,
    //表格配置
    modalConfigs: {
      type: Object,
      default: () => ({}),
    },
    //插槽数据
    slotData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    modalConfig() {
      return Object.assign(
        {
          //页面标题
          pageTitle: "",
          //表格模式(默认弹出增加数据，other行内编辑)
          model: "table",
          //顶部合并(仅适用于顶部表单框及按钮很少的情况)
          topMerge: false,
          //是否支持选中
          selected: true,
          //是否显示分页
          showPagination:true,
          //是否多选 radio单选  checkbox多选
          selectedType: "radio",
          //唯一标识
          majorKey: "",
          //选择器宽度
          width:600,
          //显示名名称
          majorName: "",
          topForm: [],
          //是否收缩
          isShrink: true,
          //顶部按钮
          topBtnList: [],
          //是否显示顶部显示框
          showList: true,
          //表格数据
          tableData: ref([]),
          //树形数据
          treeData: ref([]),
          //表格列
          columns: [],
          replaceFields: {
            children: "children",
            title: this.modalConfigs.majorName,
            key: this.modalConfigs.majorKey,
            value: this.modalConfigs.majorKey,
          },
          //分页
          pagination: {
            showTotal: (total) => `共 ${total} 条`,
            total: 1,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30", "50"],
            current: 1,
            pageSize: 10,
          },
        },
        this.modalConfigs
      );
    },
    // 表格过滤列
    tableColumns: function () {
      const columns = this.modalConfigs.columns;
      let colArr = <any>[];
      if (columns && Array.isArray(columns) && columns.length) {
        columns.forEach((col) => {
          if (col.key !== "options") {
            colArr.push(col);
          }
        });
      }
      return colArr;
    },
    //选中配置项
    rowSelection(row) {
      let obj = {};
      if (this.modalConfig.selected) {
        obj = {
          selectedRowKeys: this.popupConfig.selectedRowKeys,
          onChange: this.tableFunction.onSelectChange,
          type: this.modalConfig.selectedType,
        };
      } else {
        obj = "";
      }
      return obj;
    },
  },
  created() {
    this.modalConfigs.topForm.form.forEach((item) => {
      if (item.soltName) {
        (this as any).slot.modal.push(item);
      }
    });

    this.getOptions();
  },
  setup(props, content) {
    const proxy: any = getCurrentInstance()?.proxy; //获取vue实例上下文
    let optionsObj = reactive({});
    //获取枚举数据
    const getOptions = function () {
      return new Promise<void>((resolve, reject) => {
        props.modalConfigs.columns.forEach((item) => {
          if (item.dictKey) {
            proxy.$dict(item.dictKey).then((res) => {
              optionsObj[item.key + "list"] = res;
              res.forEach((val) => {
                if (!optionsObj.hasOwnProperty(item.key + "map")) {
                  optionsObj[item.key + "map"] = {};
                  ("");
                }
                optionsObj[item.key + "map"][val.value] = val.label;
              });
              proxy.tabelKey++;
              resolve();
            });
          }
        });
      });
    };
    /* 顶部按钮方法 */
    const topFunction = {
      topOperate: function (type) {
        let form = proxy.$refs["topSearchForm"]; //获取表单
        let data = {
          type,
          formData: form.getFormData().formData,
          selectedData: proxy.popupConfig.selData,
        };
        if (proxy.slot.modal.length !== 0) {
          proxy.slot.modal.forEach((item) => {
            data.formData[item.soltName] = proxy.slotData[item.soltName] || "";
          });
        }
        switch (type) {
          //查询
          case "search":
            proxy.modalConfig.treeData = [];
            proxy.modalConfig.tableData = [];
            proxy.popupConfig.selectedRowKeys = [];
            proxy.popupConfig.deptCheckedKeys = [];
            proxy.popupConfig.deptTreeData = [];
            break;
          // 重置
          case "reset":
            form.resetValidation();
            break;
          default:
            break;
        }
        //调用父组件绑定方法
        proxy.$emit("topOperate", data, (res) => {
          //执行完重新将选项选中
          let arr = <any>[];
          proxy.popupConfig.selData.forEach((item) => {
            arr.push(item[proxy.modalConfig.majorKey]);
          });
          if (proxy.modalConfig.model === "table") {
            proxy.popupConfig.selectedRowKeys = arr;
            proxy.tableFunction.onSelectChange(arr, true);
          } else {
            proxy.popupConfig.deptCheckedKeys = arr;
          }
        });
      },
    };

    /* 表格相关方法 */
    const tableFunction = {
      //操作按钮方法
      itemOptions: function (type, row, index) {
        let data = {
          type,
          row,
          table: proxy.formTableOption.tableData,
        };
        var that = proxy;
        that.$emit("tableOperate", data, (res) => {
          proxy.formState = res;
        });
      },
      //选中记录方法  isInit是否初始化
      onSelectChange: function (selectedRowKeys, isInit) {
        // 原选中数据
        var selectedData = <any>[];
        proxy.modalConfig.tableData.forEach((one) => {
          if (selectedRowKeys.indexOf(one[proxy.modalConfig.majorKey]) != -1) {
            selectedData.push({
              ...one,
            });
          }
        });

        // 原选中数据
        var originalSelData = JSON.parse(
          JSON.stringify(proxy.popupConfig.selRow)
        );
        proxy.popupConfig.selRow = selectedData;

        // 当前选中数据
        if (proxy.modalConfig.selectedType === "radio" && !isInit) {
          // 单选
          proxy.popupConfig.selData = selectedData;
        } else {
          // 多选
          // 删除数据
          var deleteData = <any>[];
          originalSelData.forEach((one) => {
            // 查询新选中数据中是否有原数据，没有则为删除数据
            var searchRes = proxy.$common.searchArr(
              selectedData,
              proxy.modalConfig.majorKey,
              one[proxy.modalConfig.majorKey]
            );
            if (!searchRes.result) {
              deleteData.push(one);
            }
          });
          // 更新顶部选中数据
          deleteData.forEach((one) => {
            var searchRes = proxy.$common.searchArr(
              proxy.popupConfig.selData,
              proxy.modalConfig.majorKey,
              one[proxy.modalConfig.majorKey]
            );
            if (searchRes.result) {
              proxy.popupConfig.selData.splice(searchRes.index, 1);
            }
          });

          selectedData.forEach((one) => {
            var searchRes = proxy.$common.searchArr(
              proxy.popupConfig.selData,
              proxy.modalConfig.majorKey,
              one[proxy.modalConfig.majorKey]
            );
            if (!searchRes.result) {
              proxy.popupConfig.selData.push({ ...one });
            }
          });
        }
        // 设置表格选中行ID
        proxy.popupConfig.selectedRowKeys = selectedRowKeys;
        (this as any).tabelKey++;
      },
      // 点击行
      customRow: function (record, idx) {
        return {
          onClick: (event) => {
            var selId = record[proxy.modalConfig.majorKey],
              selArr = proxy.popupConfig.selectedRowKeys;
            var selIdx = selArr.indexOf(selId);
            if (selArr.length > 1 && selIdx != -1) {
              // 多选
              selArr.splice(selIdx, 1);
            } else if (selArr.length < 2) {
              // 单选
              selArr = [selId];
            }
            proxy.tableFunction.onSelectChange(selArr);
          },
        };
      },
    };

    return {
      topFunction,
      getOptions,
      optionsObj,
      tableFunction,
    };
  },

  methods: {
    // 初始化弹窗
    initPopup: function (init) {
      //初始化顶部显示区域数据
      if (
        Array.isArray(this.value) &&
        this.value.length &&
        this.modalConfig.dataUrl
      ) {
        let data = {
          type: this.modalConfig.dataType,
          ids: this.value.join(","),
        };
        (this as any).$axios
          .get(this.modalConfig.dataUrl, { params: data })
          .then((res) => {
            if (res.data.code == 200) {
              if (this.modalConfig.selectedType === "radio") {
                (this as any).popupConfig.selData = [res.data.data[0]];
              } else {
                this.popupConfig.selData = Array.isArray(res.data.data)
                  ? res.data.data
                  : [];
              }
              (this as any).popupConfig.selectedRowKeys = this.value;
            } else {
              (this as any).$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            (this as any).$message.error("服务器异常");
          });
      } else {
        if (init) {
          // 获取选中项
          this.popupConfig.selData = JSON.parse(JSON.stringify(this.value));
        }
      }
      if (this.modalConfig.model === "tree") {
        //设置展示源数据
        (this as any).popupConfig.deptData = this.modalConfig.treeData;
        //处理为树形结构
        this.popupConfig.deptTreeData = this.parseTree(
          this.modalConfig.treeData
        );

        this.popupConfig.allDeptNodeKeys = (this as any).modalConfig.treeData.map(
          (o) => o[this.modalConfig.majorKey]
        );
        //处理展开及选择
        this.popupConfig.deptExpandedKeys = (this as any).modalConfig.treeData.map(
          (o) => o[this.modalConfig.majorKey]
        );
        //默认展开
        this.popupConfig.fold = true;
        this.popupConfig.deptCheckedKeys = [];
        if (typeof (this as any).value[0] != "object") {
          (this as any).popupConfig.deptCheckedKeys = this.value;
        } else {
          (this as any).value.forEach((item) => {
            (this as any).popupConfig.deptCheckedKeys.push(
              item[this.modalConfig.majorKey]
            );
          });
        }
        (this as any).treeCheck(this.popupConfig.deptCheckedKeys);
      } else {
        var selIds = <any>[];
        // 清空表格选中行数据
        this.popupConfig.selRow = [];
        this.popupConfig.selectedRowKeys = [];

        (this as any).modalConfig.tableData.forEach((o) => {
          var searchRes = (this as any).$common.searchArr(
            this.popupConfig.selData,
            this.modalConfig.majorKey,
            o[this.modalConfig.majorKey]
          );
          if (searchRes.result) {
            selIds.push(o[this.modalConfig.majorKey]);
          }
        });
        this.tableFunction.onSelectChange(selIds, true);
        // 设置表格列
        this.popupConfig.columns = this.modalConfigs.columns;
      }
      this.tabelKey++;
      // 顶部表单内容
    },
    //解析树结构
    parseTree(data) {
      var res = <any>[],
        map = {};
      if (Array.isArray(data)) {
        data.sort(
          (a, b) => a[this.modalConfig.majorKey] - b[this.modalConfig.majorKey]
        );
        data.forEach((one) => {
          var template = {
            ...one,
            children: [],
          };
          if (!map[one.parentId]) {
            res.push(template);
          } else {
            map[one.parentId].children.push(template);
          }
          if (!map[one.deptId]) {
            map[one[this.modalConfig.majorKey]] = template;
          }
        });
      }
      return res;
    },

    // 选项操作
    itemOptions: function (type, data) {
      var popupArr = this.popupConfig.selData,
        majorKey = this.modalConfig.majorKey;
      switch (type) {
        case "popupRemove":
          // 弹窗选中项删除
          if (this.modalConfig.model === "table") {
            var searchRe = (this as any).$common.searchArr(
              this.popupConfig.selRow,
              majorKey,
              data[majorKey]
            );
            if (searchRe.result) {
              var selIds = <any>[];
              // 删除项在当前分布列表中
              // this.popupConfig.selectedData.splice(searchRes.index, 1);
              this.popupConfig.selRow.forEach((o) => {
                if (o[majorKey] !== data[majorKey]) {
                  selIds.push(o[majorKey]);
                }
              });
              (this as any).tableFunction.onSelectChange(selIds);
            } else {
              // 不在当前分页列表中
              for (var i = popupArr.length - 1; i >= 0; i--) {
                var one = popupArr[i];
                if (one[majorKey] == data[majorKey]) {
                  popupArr.splice(i, 1);
                  break;
                }
              }
            }
          } else {
            if (this.popupConfig.deptCheckedKeys.hasOwnProperty("checked")) {
              for (
                let i = 0;
                i < (this as any).popupConfig.deptCheckedKeys.checked.length;
                i++
              ) {
                if (
                  (this as any).popupConfig.deptCheckedKeys.checked[i] === data[majorKey]
                ) {
                  (this as any).popupConfig.deptCheckedKeys.checked.splice(i, 1);
                }
              }
              (this as any).treeCheck((this as any).popupConfig.deptCheckedKeys.checked);
            } else {
              for (
                let i = 0;
                i < this.popupConfig.deptCheckedKeys.length;
                i++
              ) {
                if (this.popupConfig.deptCheckedKeys[i] === data[majorKey]) {
                  this.popupConfig.deptCheckedKeys.splice(i, 1);
                }
              }
              (this as any).treeCheck(this.popupConfig.deptCheckedKeys);
            }
          }

          break;
      }
    },
    // 菜单权限控制变更
    controlChange: function (type) {
      switch (type) {
        case "fold":
          // 折叠
          if (this.popupConfig.fold) {
            this.popupConfig.deptExpandedKeys = [
              ...this.popupConfig.allDeptNodeKeys,
            ];
          } else {
            this.popupConfig.deptExpandedKeys = [];
          }
          break;
        case "selAll":
          // 选中
          if (this.popupConfig.selAll) {
            this.popupConfig.deptCheckedKeys = [
              ...this.popupConfig.allDeptNodeKeys,
            ];
            (this as any).treeCheck(this.popupConfig.allDeptNodeKeys);
          } else {
            this.popupConfig.deptCheckedKeys = [];
            this.popupConfig.selData = [];
          }
          break;
      }
    },
    // 表格分页
    tablePageChange: function () {
      var topForm = (this as any).$refs["topSearchForm"];
      let data = {
        formData: topForm.getFormData().formData,
        queryParams: {},
      };
      //插槽值回填
      if (this.slot.modal.length !== 0) {
        (this as any).slot.modal.forEach((item) => {
          data.formData[item.soltName] = this.slotData[item.soltName] || "";
        });
      }
      // 选中ID
      var selIds = <any>[];
      // 清空表格选中行数据
      this.popupConfig.selectedRowKeys = [];
      data.queryParams = {
        pageNum: this.modalConfig.pagination.current,
        pageSize: this.modalConfig.pagination.pageSize,
      };

      this.$emit("tablePageChange", Object.assign(data), (res) => {
        this.popupConfig.selData.forEach((o) => {
          selIds.push(o[this.modalConfig.majorKey]);
        });
        this.popupConfig.selRow = [];
        this.tableFunction.onSelectChange(selIds, true);
      });
    },

    // 部门树勾选
    treeCheck: function (checkedKeys, e) {
      // 选中数据
      var checkArr = Array.isArray(checkedKeys)
        ? checkedKeys
        : checkedKeys.checked;
      if (this.modalConfig.selectedType === "radio" && e) {
        checkArr = [e.node.eventKey];
        (this as any).popupConfig.deptCheckedKeys = [e.node.eventKey];
      }
      var majorKey = this.modalConfig.majorKey;
      var selIds = (this as any).popupConfig.selData.map((o) => o[majorKey]);
      // 添加新数据
      checkArr.forEach((id) => {
        if (selIds.indexOf(id) === -1) {
          var searchRes = (this as any).$common.searchArr(
            this.popupConfig.deptData,
            majorKey,
            id
          );
          if (searchRes.result) {
            (this as any).popupConfig.selData.push(searchRes.data);
          }
        }
      });
      // 删除数据
      for (var i = selIds.length - 1; i >= 0; i--) {
        var one = selIds[i];
        if (checkArr.indexOf(one) === -1) {
          this.popupConfig.selData.splice(i, 1);
        }
      }
    },
    // 弹窗 保存/取消
    submit: function (state) {
      if (state) {
        //总数据
        var data = JSON.parse(JSON.stringify(this.popupConfig.selData));

        //id集合
        let idList = data.map((item) => {
          return item[this.modalConfig.majorKey];
        });
        //name集合
        let nameList = data.map((item) => {
          return item[this.modalConfig.majorName];
        });
        let str = nameList.join(",");
        //name集合
        // 更新值
        this.$emit("update:value", idList);
        this.$emit("change", data, idList, str);
      }
      this.$emit("update:isShow", false);
    },
    // 顶部表单收缩
    topFormShrink: function () {
      if (this.modalConfig.isShrink === true) {
        this.popupConfig.topSearchFormShrink =
          !this.popupConfig.topSearchFormShrink;
      }
    },
  },
  watch: {
    //初始化
    "isShow": function (val) {
      if (val) {
        this.initPopup(true);
      }
    },
    "modalConfigs.treeData": function (val) {
      if (val) {
        //设置展示源数据
        (this as any).popupConfig.deptData = this.modalConfig.treeData;
        //处理为树形结构
        this.popupConfig.deptTreeData = this.parseTree(
          this.modalConfig.treeData
        );
        this.popupConfig.allDeptNodeKeys = (this as any).modalConfig.treeData.map(
          (o) => o[this.modalConfig.majorKey]
        );
        //处理展开及选择
        this.popupConfig.deptExpandedKeys = (this as any).modalConfig.treeData.map(
          (o) => o[this.modalConfig.majorKey]
        );
        //默认展开
        this.popupConfig.fold = true;
        this.popupConfig.deptCheckedKeys = [];
      }
    },
    "modalConfig.tableData": function (value) {
      (this as any).popupConfig.selectedRowKeys = this.value;
    },
  },
});
